import ShareLinks from './ShareLinks';

export default ShareLinks;
